import { render } from "./AppHero.vue?vue&type=template&id=6295cbfa&scoped=true"
const script = {}

import "./AppHero.vue?vue&type=style&index=0&id=6295cbfa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6295cbfa"]])

export default __exports__